// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Aplicar Montserrat a todo el componente */
* {
    font-family: 'Montserrat', sans-serif;
}

.history-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.containerButtons {
    display: flex;
    gap: 12px;
    margin-bottom: 1.5rem;
}

.transactions-btns {
    display: flex;
    gap: 15px;
}

.transactions-btns a {
    font-weight: bold;
}

.list-group-item {
    border-bottom: 1px #4f4f4f solid;
    margin-top: 15px !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}

.title {
    display: none !important;
}

.btn {
    padding: 12px 16px;
    font-size: 14px;
    border-radius: 12px;
    transition: all 0.2s ease-in-out;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
}

.btn-success {
    background-color: #E88F02;
    border-color: #E88F02;
    color: white;
}

.btn-success:hover {
    background-color: #d68502;
    border-color: #d68502;
    color: white;
}

.btn-outline-success {
    color: #E88F02;
    background-color: transparent;
    border: 1px solid #E88F02;
}

.btn-outline-success:hover {
    background-color: #E88F02;
    border-color: #E88F02;
    color: white;
}

/* Asegurar que los botones inactivos mantengan el estilo correcto */
.btn-outline-success:not(:hover):not(.active) {
    background-color: transparent;
    color: #E88F02;
}

/* Estilo activo */
.btn.active {
    background-color: #E88F02;
    border-color: #E88F02;
    color: white;
}

/* Estilos para los estados */
.badge.bg-warning {
    background-color: #ffc107 !important;
}

.badge.bg-info {
    background-color: #17a2b8 !important;
}

/* Iconos */
.bi {
    font-size: 2rem;
}

.bi-exclamation-triangle {
    color: #dc3545;
}

.bi-calendar2-x {
    color: #ffc107;
}

.back-button {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    color: #999;
    padding: 2rem 1.5rem 3rem;
    cursor: pointer;
}

.back-button span {
    color: #999;
    font-size: 1rem;
}

.detail-container {
    position: relative;
    padding: 0 1.5rem;
}

.coin-icon-circle {
    width: 70px;
    height: 70px;
    background: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    border: 1px solid #e5e5e5;
}

.coin-icon-circle img {
    width: 35px;
    height: 35px;
    opacity: 0.6;
}

.proyecto-card {
    background: white;
    border-radius: 12px;
    padding: 3rem 1rem 1.5rem;
    margin: 0;
    position: relative;
    text-align: center;
    border: 1px solid #e5e5e5;
    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);
}

.proyecto-label {
    color: #b4b4b4;
    font-size: 0.8rem;
    margin: 0;
    font-weight: normal;
}

.proyecto-title {
    font-size: 1.4rem;
    font-weight: 500;
    margin: 0.5rem 0;
    color: #000;
}

.proyecto-date {
    color: #b4b4b4;
    font-size: 0.8rem;
    margin: 0;
    font-weight: normal;
}

.info-section {
    margin-top: 2.5rem;
}

.info-item {
    padding: 2rem 0;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.info-item:last-child {
    border-bottom: none;
    padding-bottom: 3rem;
}

.info-label {
    color: #999;
    font-size: 0.4rem;
    margin: 0;
    font-weight: normal;
    opacity: 0.85;
    text-transform: none;
    letter-spacing: 0.3px;
}

.info-value {
    font-size: 0.55rem;
    font-weight: normal;
    margin: 0;
    color: #000;
    line-height: 1;
    padding-top: 0.25rem;
}

.error-message {
    color: red !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/transfer-batch/transfer-list/transfer-list.component.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,gEAAgE;AACpE;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,oEAAoE;AACpE;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,6BAA6B;AAC7B;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,WAAW;AACX;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["/* Aplicar Montserrat a todo el componente */\n* {\n    font-family: 'Montserrat', sans-serif;\n}\n\n.history-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.containerButtons {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 1.5rem;\n}\n\n.transactions-btns {\n    display: flex;\n    gap: 15px;\n}\n\n.transactions-btns a {\n    font-weight: bold;\n}\n\n.list-group-item {\n    border-bottom: 1px #4f4f4f solid;\n    margin-top: 15px !important;\n    transition: transform 0.2s ease, box-shadow 0.2s ease !important;\n}\n\n.title {\n    display: none !important;\n}\n\n.btn {\n    padding: 12px 16px;\n    font-size: 14px;\n    border-radius: 12px;\n    transition: all 0.2s ease-in-out;\n    font-weight: 500;\n    text-align: center;\n    white-space: nowrap;\n}\n\n.btn-success {\n    background-color: #E88F02;\n    border-color: #E88F02;\n    color: white;\n}\n\n.btn-success:hover {\n    background-color: #d68502;\n    border-color: #d68502;\n    color: white;\n}\n\n.btn-outline-success {\n    color: #E88F02;\n    background-color: transparent;\n    border: 1px solid #E88F02;\n}\n\n.btn-outline-success:hover {\n    background-color: #E88F02;\n    border-color: #E88F02;\n    color: white;\n}\n\n/* Asegurar que los botones inactivos mantengan el estilo correcto */\n.btn-outline-success:not(:hover):not(.active) {\n    background-color: transparent;\n    color: #E88F02;\n}\n\n/* Estilo activo */\n.btn.active {\n    background-color: #E88F02;\n    border-color: #E88F02;\n    color: white;\n}\n\n/* Estilos para los estados */\n.badge.bg-warning {\n    background-color: #ffc107 !important;\n}\n\n.badge.bg-info {\n    background-color: #17a2b8 !important;\n}\n\n/* Iconos */\n.bi {\n    font-size: 2rem;\n}\n\n.bi-exclamation-triangle {\n    color: #dc3545;\n}\n\n.bi-calendar2-x {\n    color: #ffc107;\n}\n\n.back-button {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    color: #999;\n    padding: 2rem 1.5rem 3rem;\n    cursor: pointer;\n}\n\n.back-button span {\n    color: #999;\n    font-size: 1rem;\n}\n\n.detail-container {\n    position: relative;\n    padding: 0 1.5rem;\n}\n\n.coin-icon-circle {\n    width: 70px;\n    height: 70px;\n    background: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: -35px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 10;\n    border: 1px solid #e5e5e5;\n}\n\n.coin-icon-circle img {\n    width: 35px;\n    height: 35px;\n    opacity: 0.6;\n}\n\n.proyecto-card {\n    background: white;\n    border-radius: 12px;\n    padding: 3rem 1rem 1.5rem;\n    margin: 0;\n    position: relative;\n    text-align: center;\n    border: 1px solid #e5e5e5;\n    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);\n}\n\n.proyecto-label {\n    color: #b4b4b4;\n    font-size: 0.8rem;\n    margin: 0;\n    font-weight: normal;\n}\n\n.proyecto-title {\n    font-size: 1.4rem;\n    font-weight: 500;\n    margin: 0.5rem 0;\n    color: #000;\n}\n\n.proyecto-date {\n    color: #b4b4b4;\n    font-size: 0.8rem;\n    margin: 0;\n    font-weight: normal;\n}\n\n.info-section {\n    margin-top: 2.5rem;\n}\n\n.info-item {\n    padding: 2rem 0;\n    border-bottom: 1px solid #e0e0e0;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.info-item:last-child {\n    border-bottom: none;\n    padding-bottom: 3rem;\n}\n\n.info-label {\n    color: #999;\n    font-size: 0.4rem;\n    margin: 0;\n    font-weight: normal;\n    opacity: 0.85;\n    text-transform: none;\n    letter-spacing: 0.3px;\n}\n\n.info-value {\n    font-size: 0.55rem;\n    font-weight: normal;\n    margin: 0;\n    color: #000;\n    line-height: 1;\n    padding-top: 0.25rem;\n}\n\n.error-message {\n    color: red !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
